module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "P_Heading_2",
    attrs: {
      "id": "auto_bookmark_toc_4"
    }
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THERE ARE")]), _vm._v(" not enough vowels in the English language to describe how delighted I am with the illustrations for "), _c('i', [_vm._v("Elf Shot")]), _vm._v(". If I tried only dolphins and French Bulldogs would have any clue what was going on. Using only my rambling and a few bizarre stick figure drawings to explain how I wanted to set the scene Emily captured the perfect essence of the story and characters just as I imagined them. I am always impressed by anyone who can draw (the bizarre stick figure drawings are the height of my artistic talents), and had previously been a fan of Em's adorable cartoon series"), _c('i', [_vm._v(", Stupid Fox. ")]), _vm._v("However, being part of the process from start to finish was an amazing experience.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }, [_vm._v("I adore Em's vision of the "), _c('i', [_vm._v("Elf Shot ")]), _vm._v("world and I hope you do as well. She is amazingly talented.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent__OPENPAR_1_CLOSEPAR_"
  }, [_vm._v("Tamm")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6344eac3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 66
// module chunks = 0